import React, { useEffect, useLayoutEffect, useRef, useState } from "react";

interface AutoTextAreaProps {
  className?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onEnter13?: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void;
  icon13css?: string;
  icon13small?: boolean;
  placeholder?: string;
  style?: React.CSSProperties;
  readOnly?: boolean;
  maxLength?: number | undefined;
}

const AutoTextArea: React.FC<AutoTextAreaProps> = ({
  className = "form-control",
  value = "",
  onChange = () => { },
  onEnter13 = () => { },
  placeholder = "",
  style = {},
  icon13css = null,
  icon13small = false,
  readOnly = false,
  maxLength = undefined,
  // id
}) => {
  // Handle key down to detect "Enter" key
  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === "Enter" && onEnter13) {
      onEnter13(e); // Call the custom onEnter13 event handler
    }
  };

  const handleClick13 = () => {
    if (onEnter13) {
      const e = new KeyboardEvent("keydown", { key: "Enter" });
      // Create a fake input element
      const inputElement = document.createElement("input");

      // Convert native event to a React synthetic event using Object.assign
      const reactEvent = Object.assign({}, e, {
        currentTarget: inputElement,
        target: inputElement,
        nativeEvent: e,
        preventDefault: () => e.preventDefault(),
        stopPropagation: () => e.stopPropagation(),
      }) as unknown as React.KeyboardEvent<HTMLTextAreaElement>;

      onEnter13(reactEvent);
    }
  };

  const [valueMine, setValueMine] = useState<any>(value);
  useEffect(() => {
    setValueMine(value);
  }, [value])

  const handleClear = () => {
    setValueMine("");
    const simulatedEvent = {
      target: { value: "" },
    } as React.ChangeEvent<HTMLTextAreaElement>;
    onChange(simulatedEvent);
  };

  const ref = useRef<HTMLTextAreaElement>(null);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    onChange(e);

    // if (ref.current) {
    //   ref.current.style.height = "auto";
    //   ref.current.style.height = ref.current.scrollHeight + "px";
    // }
  };

  const resize = (callFrom: string) => {
    // console.log('resize from ' + callFrom + (ref.current ? ' has ref' : ' no ref'));
    if (!ref.current) return;
    ref.current.style.height = "auto";
    ref.current.style.height = ref.current.scrollHeight + "px";
  };

  useEffect(() => {
    resize('value change');
  }, [value]);

  // useLayoutEffect(() => {
  //   resize();
  // }, [value]);
  useEffect(() => {
    resize('ref change');
  }, [ref]);

  useEffect(() => { setTimeout(() => { resize('timer'); }, 300); }, []);
  useEffect(() => { setTimeout(() => { resize('timer'); }, 400); }, []);
  useEffect(() => { setTimeout(() => { resize('timer'); }, 500); }, []);
  useEffect(() => { setTimeout(() => { resize('timer'); }, 600); }, []);
  useEffect(() => { setTimeout(() => { resize('timer'); }, 700); }, []);
  useEffect(() => { setTimeout(() => { resize('timer'); }, 800); }, []);
  useEffect(() => { setTimeout(() => { resize('timer'); }, 900); }, []);
  useEffect(() => { setTimeout(() => { resize('timer'); }, 1000); }, []);
  useEffect(() => { setTimeout(() => { resize('timer'); }, 1500); }, []);

  // useLayoutEffect(() => {
  //   if (!ref.current) return;

  //   const ro = new ResizeObserver(() => {
  //     resize("resize observer");
  //   });

  //   ro.observe(ref.current);

  //   return () => ro.disconnect();
  // }, []);


  const fontSize = icon13small ? "1.2em" : "1.5em";
  className = (className ?? "") + " text-area-nobar";
  const charCount = (valueMine ?? "").length;
  return (
    <div style={{ position: "relative", width: "100%" }}>
      <textarea
        ref={ref}
        className={className}
        value={valueMine}
        onChange={(e) => {
          handleChange(e);
          setValueMine(e.target.value)
        }}
        placeholder={placeholder}
        style={style}
        readOnly={readOnly}
        maxLength={maxLength}
      />
      {maxLength !== undefined && (
        <div style={{ textAlign: "right", fontSize: "0.75em", color: charCount >= maxLength ? "#dc3545" : "#888", marginTop: 2 }}>
          {charCount}/{maxLength}
        </div>
      )}
      {(valueMine && !readOnly) && (
        <i
          onClick={handleClear}
          style={{
            position: "absolute",
            right: icon13css ? "28px" : "2px",
            top: "54%",
            transform: "translateY(-50%)",
            cursor: "pointer",
            color: "#888",
            fontSize: fontSize
          }}
          className="bx bx-x"
        ></i>
      )}

      {icon13css && (
        <i
          onClick={handleClick13}
          style={{
            position: "absolute",
            right: "2px",
            top: "54%",
            transform: "translateY(-50%)",
            cursor: "pointer",
            color: "#888",
            fontSize: fontSize
          }}
          className={icon13css}
        ></i>
      )}

    </div>
  );
};

export default AutoTextArea;
